import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhoneCall, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../SafeIcon';

const CtaSection = () => {
  return (
    <section className="py-20 relative overflow-hidden bg-secondary">
      {/* Abstract Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" />
        </svg>
      </div>
      
      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Restore Your Comfort?
          </h2>
          <p className="text-lg text-blue-100 mb-10 max-w-2xl mx-auto">
            Whether you need emergency repairs, a new installation, or regular maintenance, NorthPeak Heating & Cooling is here to help 24/7.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <Link to="/quote" className="btn-primary w-full sm:w-auto text-lg px-8 py-4">
              Request Free Estimate <SafeIcon icon={FiArrowRight} className="ml-2" />
            </Link>
            <a href="tel:5145550122" className="inline-flex items-center justify-center px-8 py-4 font-semibold text-white transition-all duration-300 rounded-md bg-white/10 hover:bg-white/20 border border-white/30 focus:outline-none w-full sm:w-auto text-lg">
              <SafeIcon icon={FiPhoneCall} className="mr-2" /> Call (514) 555-0122(demo)
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;